import { f as r } from "./function-call.js";
import { a as t } from "./an-object.js";
import { g as o } from "./get-method.js";
var a = function a(_a, i, f) {
  var e, n;
  t(_a);
  try {
    if (!(e = o(_a, "return"))) {
      if ("throw" === i) throw f;
      return f;
    }
    e = r(e, _a);
  } catch (r) {
    n = !0, e = r;
  }
  if ("throw" === i) throw f;
  if (n) throw e;
  return t(e), f;
};
export { a as i };